import clsx from "clsx";
import styles from "./SenderChip.module.css";

/**
 * A registered sender identity, drawn with a perforated edge — the sender is
 * the stamp on the message, and callers never get to set From.
 */
export function SenderChip({
  senderKey,
  className,
}: {
  senderKey: string;
  className?: string;
}) {
  return <span className={clsx(styles.chip, className)}>{senderKey}</span>;
}
